import { useChatboxStore } from "../../store";
import { TextContent } from "./Text";
import type { MessagingMessage } from "@/model/messaging";
import { useTranslations } from "next-intl";

interface ResponseSuggestion {
  message: string;
}

interface SuggestionData {
  responses?: ResponseSuggestion[];
}

interface SuggestionMessageProps {
  message: MessagingMessage;
}

export const SuggestionMessage = ({ message }: SuggestionMessageProps) => {
  const {
    use: { options },
  } = useChatboxStore();
  const t = useTranslations("chatbox.content.suggestion");
  if (!options?.debugMode?.enabled) {
    return;
  }
  return (
    <div className="flex flex-col gap-2 text-sm">
      <span className="font-bold">{t("suggestions")}</span>
      <ResponseSuggestions message={message} />
    </div>
  );
};

const ResponseSuggestions = ({ message }: SuggestionMessageProps) => {
  const suggestionData = message.payload.data as SuggestionData;
  const t = useTranslations("chatbox.content.suggestion");
  if (!suggestionData.responses || suggestionData.responses.length === 0) {
    return null;
  }
  return (
    <div className="flex gap-2 border-t py-1 text-sm">
      <span className="w-20 shrink-0 font-semibold">{t("response")}</span>
      <div className="flex grow flex-col gap-1">
        {suggestionData.responses.map((suggestion, index) => (
          <div key={index}>
            <TextContent text={suggestion.message} />
          </div>
        ))}
      </div>
    </div>
  );
};
